import GSLogo from "../../Media/Logo.svg";
type Props = {
  scrolled?: boolean;
  small?: boolean;
  style?: React.CSSProperties;
};

export const Logo = ({ scrolled, small = false, style }: Props) => {
  const largeStyles = {
    height: "auto",
    width: "50%",
    filter: scrolled ? "none" : "drop-shadow(8px 8px 0px rgba(0,0,0,0.3))",
    transition: "all 0.3s ease",
  };

  const smallStyles: React.CSSProperties = {
    height: "4rem",
  };

  const styles = small ? smallStyles : largeStyles;
  return <img className={"main-logo"} style={{ ...styles, ...style }} src={GSLogo} alt="Logo" />;
};
